module.exports = __webpack_public_path__ + "static/img/news-03.881fac7.png";


//////////////////
// WEBPACK FOOTER
// ./static/news-03.png
// module id = Vor2
// module chunks = 4